import { Switch } from '@/components/ui/switch';
import { FuncResourceDetail } from '@/types/use';
import { Loader } from 'lucide-react';
import { memo, useState } from 'react';

export type TableAGSwitchProps<T = {}> = {
    /**object data switch nhận nào */
    data: T;
    /**trường boolean sẽ change data với switch */
    field: keyof T;
    /**callback update API  */
    onChange: (data: T) => Promise<void>;
    /**disabled switch */
    disabled?: boolean;

    /**Phần quyền cho nút này (nếu có) */
    auth?: FuncResourceDetail;
};

export const TableAGSwitch = memo((props: TableAGSwitchProps) => {
    const { data, field, onChange, disabled = false, auth } = props;
    const [isLoading, setIsLoading] = useState(false);

    const handleCheckedChange = (checked: boolean) => {
        if (
            field &&
            typeof data === 'object' &&
            typeof onChange === 'function'
        ) {
            setIsLoading(true);
            let _data: any = { ...data };
            _data[field] = checked;
            onChange(_data).finally(() => {
                setIsLoading(false);
            });
        }
    };

    const isAllow = typeof auth === 'object' ? auth.isAllowed : true;
    const isChecked: boolean = data?.[field] ?? false;
    return (
        <div className='relative mt-2 flex h-full w-fit items-center'>
            <Switch
                checked={isChecked}
                onCheckedChange={handleCheckedChange}
                disabled={disabled || isLoading || !isAllow}
            />

            {isLoading && (
                <div className='absolute inset-0 z-[1] flex items-center justify-center'>
                    <Loader size={14} className='animate-spin' />
                </div>
            )}
        </div>
    );
});

TableAGSwitch.displayName = 'TableAGSwitch';
